// src/components/tier/useSeasonLog.js
import { useEffect, useRef, useState } from "react";
import { parseFullScrimLogP } from "../../utils/excelParser";

const EMPTY = { sheetName: "", games: [] };

/**
 * โหลด log ทั้งซีซั่น (ชีท All_Scrim) ครั้งเดียวตอนที่ผู้ใช้ขอ — ไฟล์เวิร์กบุ๊ก
 * ใหญ่หลายสิบ MB จะได้ไม่ถ่วงตอนเปิดหน้า
 *
 * ห้ามเอา loading/log ไปใส่ใน deps ของ effect ที่ยิงโหลด: effect จะรีรันทันที
 * ที่ setLoading(true) แล้ว cleanup ตัวก่อนจะ cancel งานของตัวเอง → ค้าง
 * "กำลังโหลด..." ตลอดกาล (เจอตอนกดใช้จริงในเบราว์เซอร์) ใช้ ref กันยิงซ้ำแทน
 *
 * ด้วยเหตุผลเดียวกัน ปิดการ์ด/สลับกองระหว่างพาร์สก็ไม่ทิ้งผลที่พาร์สเสร็จแล้ว —
 * งานหนักทำไปแล้ว เก็บไว้ใช้เลย ทิ้งเฉพาะตอนมีคำขอใหม่แซง (อัปโหลดไฟล์อื่น)
 */
export function useSeasonLog(excelFile, enabled, parse = parseFullScrimLogP) {
  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(false);
  const requested = useRef(false);
  const reqId = useRef(0);

  useEffect(() => {
    requested.current = false;
    reqId.current += 1; // ผลของไฟล์เก่าที่ยังค้างอยู่ ห้ามลงมาทับไฟล์ใหม่
    setLog(null);
    setLoading(false);
  }, [excelFile]);

  useEffect(() => {
    if (!enabled || !excelFile || requested.current) return;
    requested.current = true;
    const id = (reqId.current += 1);
    setLoading(true);
    (async () => {
      let res = EMPTY;
      try {
        res = (await parse(excelFile)) || EMPTY;
      } catch (e) {
        res = EMPTY;
      }
      if (reqId.current !== id) return;
      setLog(res);
      setLoading(false);
    })();
  }, [enabled, excelFile, parse]);

  return { log, loading };
}
